// Lists (work orders, global search): keep the page's scroll position per list URL, so coming back from a detail
// page lands on the same rows. Saved when leaving the list; restored once the list data has loaded, only when the
// user came back (browser back / Back to search results), never when the list is opened fresh (side menu).
const KEY = "listScroll:";

function scroller() {
  return document.scrollingElement || document.documentElement;
}

export function saveListScroll(path) {
  try {
    sessionStorage.setItem(KEY + path, String(Math.round(scroller().scrollTop)));
  } catch (e) { /* storage blocked: nothing to restore later */ }
}

// stored position for this URL (read once), or null
export function takeListScroll(path) {
  try {
    const v = sessionStorage.getItem(KEY + path);
    sessionStorage.removeItem(KEY + path);
    return v == null ? null : Number(v) || 0;
  } catch (e) {
    return null;
  }
}

// came here with browser back (vue-router keeps the page we left in history.state.forward)
export function cameBack() {
  return !!(window.history.state && window.history.state.forward);
}

// after the rows are rendered (two frames: layout + images settle)
export function restoreListScroll(y) {
  requestAnimationFrame(() => requestAnimationFrame(() => {
    scroller().scrollTop = y;
  }));
}
